var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import { useDispatch } from "react-redux";
import { SET_FILTER_S_REVIEW } from "../../../reducers/shoppingReview";
import styled from "styled-components";
import { scrollTo } from "../../../utils/util";
var PageCompoenent = function (_a) {
    var reviewFilter = _a.reviewFilter, reviewTotal = _a.reviewTotal;
    var dispatch = useDispatch();
    var page = reviewFilter.page, sort = reviewFilter.sort, marksCheck = reviewFilter.marksCheck, blockPage = reviewFilter.blockPage, //페이징 몇개씩 출력
    pageSize = reviewFilter.pageSize, //한페이지 리스트 개수
    marks = reviewFilter.marks;
    var activeSize = Math.ceil(page / blockPage);
    var pageFullSize = Math.ceil(reviewTotal / pageSize);
    var startPage = (activeSize * blockPage) - (blockPage - 1);
    if (startPage <= 1)
        startPage = 1;
    var endPage = activeSize * blockPage;
    if (pageFullSize <= endPage)
        endPage = pageFullSize;
    var generatePageNumbers = function () {
        var pageNumbers = [];
        for (var i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };
    var goScroll = function () {
        scrollTo('.tab_contents_target3', -126, 'auto');
    };
    var goPage = function (p) {
        dispatch({
            type: SET_FILTER_S_REVIEW,
            payload: { page: p }
        });
    };
    var onClickPage = function (p) {
        goScroll();
        goPage(p);
    };
    var onClickStart = function () {
        goScroll();
        goPage(1);
    };
    var onClickPrev = function () {
        goScroll();
        goPage((startPage - 1));
    };
    var onClickNext = function () {
        goScroll();
        goPage((startPage + blockPage));
    };
    var onClickEnd = function () {
        goScroll();
        goPage(pageFullSize);
    };
    return (React.createElement(Wrap, { className: "pagination" },
        activeSize !== 1 && (React.createElement(React.Fragment, null,
            React.createElement(ArrowButton, { className: "button", type: "button", onClick: onClickStart }, "\uCC98\uC74C"),
            React.createElement(ArrowButton, { className: "button", type: "button", onClick: onClickPrev }, "\uC774\uC804"))),
        generatePageNumbers().map(function (v) { return (React.createElement("button", { key: v, className: "pagingBtn ".concat(v === page ? 'active unHoverPointer' : ''), onClick: function () { v !== page && onClickPage(v); } }, v)); }),
        endPage !== pageFullSize && (React.createElement(React.Fragment, null,
            React.createElement(ArrowButton, { className: "button", type: "button", onClick: onClickNext }, "\uB2E4\uC74C"),
            React.createElement(ArrowButton, { className: "button", type: "button", onClick: onClickEnd }, "\uB05D")))));
};
export default PageCompoenent;
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin:50px 0;\n    display: flex;\n    justify-content: center;\n\n    .pagingBtn{\n        width: 28px;\n        margin: 0 2.5px;\n        border: 1px solid transparent;\n        font-size: 14px;\n        color: #666;\n        font-weight: bold;\n        padding: 0;\n        background:transparent;\n        line-height: 1.9;\n    }\n    .pagingBtn:hover{\n        border-color: #418ded;\n    }\n    .active{\n        background: #418ded;\n        border-color: transparent;\n        color: #fff;\n    }\n    .unHoverPointer{\n        cursor:auto;\n    }\n"], ["\n    margin:50px 0;\n    display: flex;\n    justify-content: center;\n\n    .pagingBtn{\n        width: 28px;\n        margin: 0 2.5px;\n        border: 1px solid transparent;\n        font-size: 14px;\n        color: #666;\n        font-weight: bold;\n        padding: 0;\n        background:transparent;\n        line-height: 1.9;\n    }\n    .pagingBtn:hover{\n        border-color: #418ded;\n    }\n    .active{\n        background: #418ded;\n        border-color: transparent;\n        color: #fff;\n    }\n    .unHoverPointer{\n        cursor:auto;\n    }\n"])));
var ArrowButton = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &.button {\n        margin: 0 2.5px;\n        border: 1px solid #d3d3d3;\n        padding: 0 10px;\n        font-size: 13px;\n        background: #f7f7f7;\n\n        &:hover {\n            border-color: #418ded\n        }\n    }\n"], ["\n    &.button {\n        margin: 0 2.5px;\n        border: 1px solid #d3d3d3;\n        padding: 0 10px;\n        font-size: 13px;\n        background: #f7f7f7;\n\n        &:hover {\n            border-color: #418ded\n        }\n    }\n"])));
var templateObject_1, templateObject_2;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/review/shopping/page.tsx
// module id = 255
// module chunks = 0